import { getGlobal } from '../global';

import { DEBUG } from '../config';
import { selectTabState } from '../global/selectors';
import { IS_SHELL } from './browser/shellContainer';
import { callEventUnreadCountNative } from './nativeBridge';

let lastShellCount: number | undefined;

function reportToShell(unreadCount: number) {
  if (!IS_SHELL || unreadCount === lastShellCount) return;
  lastShellCount = unreadCount;
  callEventUnreadCountNative(unreadCount);
}

export function updateAppBadge(unreadCount: number) {
  reportToShell(unreadCount);
  if (!selectTabState(getGlobal()).isMasterTab) return;
  if (typeof window.navigator.setAppBadge !== 'function') {
    return;
  }

  window.navigator.setAppBadge(unreadCount).catch((err) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  });
}
